import React from 'react'

import { useDispatch } from 'react-redux'

import {
  HowGoustoFoodBoxesWorkPage,
  MealPlanningPage,
  FoodBoxPage,
} from '@features/marketing-pages'

import { applyPromoCode } from 'actions/home'
import { redirect } from 'actions/redirect'

export function HowGoustoWorks() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return <HowGoustoFoodBoxesWorkPage startOnboarding={handleClick} />
}

export function MealPlanning() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return <MealPlanningPage startOnboarding={handleClick} />
}

export function FoodBox() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCode())

    dispatch(redirect(path))
  }

  return <FoodBoxPage startOnboarding={handleClick} />
}
